import {LoginSectionModel} from './login-section.model';
import {BenefitSectionModel} from './benefit-section.model';
import {SliderModel} from './slider.model';
import { LinksModel } from './links.model';

export class HomeModel {
    tncLink: string;
    loginsection: LoginSectionModel;
    benefitsection: BenefitSectionModel;
    slider: SliderModel[];
    links: LinksModel [];

constructor() {
    this.loginsection = undefined;
    this.benefitsection = undefined;
    this.slider = undefined;
    this.links = undefined;
  }
}
// Defining a homeData constant to initialize the HomePage Model to avoid console errors while loading the page
export const HOME_DATA = {
    "tncLink": "",
    "loginsection": {
      "desc1": "",
      "desc2": "",
      "contact": "",
      "contact_tty": "",
      "contact_fn": "",
      "desc2_fn": "",
      "login_desc1": "",
      "login_desc2": "",
      "button_name": "",
      "button_link": ""
    },
    "benefitsection": {
      "header": "",
      "desc": "",
      "linkDesc": "",
      "image": "",
      "shopLinkName" : "",
      "manageLinkName" : "",
    },
    "slider": [
      {
        "title": "",
        "color": "",
        "image": "",
        "smallImage": "",
        "shortDescription": "",
        "descFlag": true,
        "legalTxt": "",
        "subLink": "",
        "buttonFlag": true,
        "buttonLink": "",
        "eyeBrowText":"",
        "captionBg": false,
        "actionLabel": "",
      }
    ],
     "links": [
       {
          "image" : "",
          "rlink" : "",
          "title" : "",
           "linkName" : "",
        },
      ]
  }
